<template>
    <section ref="storesLocation" class="stores-locations">
        <div class="stores-locations__container container">
            <StoresList
                class="stores-locations__list"
                :title="$t('storesLocationsListTitle')"
                :stores="stores"
                :activeStoreId="activeStoreId"
                :isPreloader="isPreloader"
                @set-active-store="setActiveStore"
            />
            <Map
                v-if="!isUnderOrEqualViewport1024"
                class="stores-locations__map"
                :activeStore="activeStore"
                :stores="stores"
                :iconStoreActive="iconPathStoreActive"
                :iconStoreDisabled="iconPathStoreDisabled"
            />
            <StoreWindow
                :isActive="isStoreWindowActive"
                :activeStore="activeStore"
                :stores="stores"
                :iconStoreActive="iconPathStoreActive"
                :iconStoreDisabled="iconPathStoreDisabled"
                @close="setActiveStore(null)"
            />
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex';
import viewport from '~/mixins/viewport';
import { createStoreItem } from './types';

export default {
    name: 'StoresLocations',
    mixins: [viewport],
    data() {
        return {
            isPreloader: true,
            isStoreWindowActive: false,
            activeStoreId: null,
            stores: [],

            observer: null
        };
    },
    watch: {
        activeStore(newVal, oldVal) {
            if (newVal) this.setIsStoreWindowActive(true);
            else this.setIsStoreWindowActive(false);
        },
        isAvailableActiveStore(newVal) {
            if (newVal) {
                this.setActiveStore(this.stores[0].id);
            }
        }
    },
    computed: {
        ...mapGetters({
            globalSettings: 'global/globalSettings'
        }),
        activeStore() {
            return this.stores.find(s => s.id === this.activeStoreId) || null;
        },

        iconPathStoreActive() {
            return this.globalSettings.mapIcons.storeIconActive || null;
        },
        iconPathStoreDisabled() {
            return this.globalSettings.mapIcons.storeIconDisabled || null;
        },
        isAvailableActiveStore() {
            return this.stores[0] && !this.isUnderOrEqualViewport1024;
        }
    },
    methods: {
        setIsStoreWindowActive(flag) {
            if (this.isUnderOrEqualViewport1024) {
                this.isStoreWindowActive = flag;
                document.body.classList[flag ? 'add' : 'remove']('--blocked');
            }
        },
        setActiveStore(id) {
            const isValidStoreId = typeof id === 'number' && this.stores.find(s => s.id === id) ? true : false;

            if (id === null) this.activeStoreId = null;
            else if (isValidStoreId) this.activeStoreId = id;
            else throw new Error('Unvalid store id, valids stores are based in key stores');
        },

        async fetchStoresLocations() {
            this.isPreloader = true;
            try {
                const { data } = await this.$api.contacts.getStoresLocations();

                this.stores = data.map(item => {
                    return createStoreItem({
                        id: item.shopId,
                        coordinates: { lat: item.coordinates.lat, lng: item.coordinates.lng },
                        city: item?.addresses?.region?.name || '',
                        address: item.addresses.address,
                        schedule: item.schedule,
                        phones: item.phones,
                        pinTitle: item.tooltipPin,
                        iframe: item.iframe
                    });
                });
            } catch (error) {
                this.isPreloader = false;
                throw new Error(`Unvalid fetching in fetchStoresLocations`);
            } finally {
                this.isPreloader = false;
            }
        }
    },
    components: {
        Map: () => import('./components/Map'),
        StoresList: () => import('./components/StoresList'),
        StoreWindow: () => import('./components/StoreWindow')
    },
    async fetch() {
        await this.fetchStoresLocations();
    }
};
</script>

<style lang="scss" scoped>
@import './styles';
</style>
